import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConstuntivoVolumiStorargeModel as ConstuntivoVolumiStorageModel } from "src/models/ConsuntivoVolumiModel";

@Component({
  selector: "app-doc-type-filter",
  templateUrl: "./doc-type-filter.component.html",
  styleUrls: ["./doc-type-filter.component.scss"],
})
export class DocTypeFilterComponent implements OnInit {
  @Input() docTypeDataInput: [] = [];
  @Input() docTypeSelected: any;
  @Output() onDocTypeChange = new EventEmitter();
  @Input() filterStorageKey: string = '';
  @Input() isBalance: boolean = false;
  
  constructor() {}

  ngOnInit() {
    if(!this.isBalance){
      if (JSON.parse(sessionStorage.getItem(this.filterStorageKey))) {
        const filterStorage: ConstuntivoVolumiStorageModel = JSON.parse(
          sessionStorage.getItem(this.filterStorageKey)
        );
        this.docTypeSelected = filterStorage.docType;
      }
    }else{
      this.docTypeSelected = null;
    }

  }

  handleDocTypeChange = (event) => {
    this.onDocTypeChange.emit(event.value);
  };
}
